const INFO = {
	main: {
		title: "Mengyun Xie",
		name: "Mengyun Xie",
		email: "xie.mengyun.ai@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/mengyunxie",
		linkedin: "https://www.linkedin.com/in/mengyunxie/"
	},

	homepage: {
		title: "I'm Mengyun Xie, a Full-Stack Developer",
		descriptions:
			"With a robust academic foundation in computer science and four years of hands-on experience as a software engineer, I possess proficiency in Java, Python, C++, and JavaScript, along with a range of technical skills. I bring a collaborative spirit, quick learning ability, a deep passion for coding and problem-solving, and a strong sense of responsibility.",
	},

	about: {
		title: "I’m Mengyun Xie. I live in coding world, where I design the future.",
		descriptions:[
			"I am currently pursuing a graduate degree in Computer Software Engineering at Northeastern University, building upon my Bachelor's in Electrical Engineering and Automation. These educational experiences have provided me with a strong foundation in technical knowledge and skills.",
			"In addition to my academic background, I have accumulated four years of software development experience in the IoT, education, and medical service industries. In my most recent role, I had the opportunity to lead a front-end team of four people, successfully implementing and delivering a new device management system.",
			"I'm a skilled and enthusiastic software engineer with a deep understanding of various programming languages, including Java, Python, c++, Swift, JavaScript, HTML, CSS, and technologies such as Rest API, MySQL, Linux, Spring Boot, React, Angular, Vue.js, Node.js, and Express.js.",
		],
	},

	resume: {
		title: "Resume",
		descriptions:
			"I'm seeking a full-time SDE position. I possess proficiency in a range of technical skills.",
	},

	educations: [
		{
			name: "Northeastern University",
			link: "https://www.northeastern.edu/",
			logo:"../neu-logo.jpg",
			major: "Master of Science in Computer Software Engineering",
			descriptions: [
			],
			location: "Seattle, WA",
			time: "Sep 2022 – April 2025"
		},
		{
			name: "Minnan Normal University",
			link: "https://en.wikipedia.org/wiki/Minnan_Normal_University",
			logo:"../Minnan_Normal_University_logo.png",
			major: "Bachelor of Engineering in Electrical Engineering and Automation",
			descriptions: [
			],
			location: "Zhangzhou, China",
			time: ""
		},
	],

	projects: [
		{
			title: "IoT Device Management Project - [Work Project]",
			descriptions: [
				"The IoT Device Management System is a B2B platform that provides businesses with a comprehensive, all-in-one IoT ecosystem, enabling enterprise clients to monitor, manage, and analyze data from thousands of connected devices in real time.",
				"On the front end, my team used React, Redux, TypeScript, and Material-UI to build an interactive dashboard that supports device management, device connection and control, user management, and role-based access control.",
				"On the back end, the project used Java, Spring Framework, MySQL, Cassandra, RESTful APIs, gRPC, Docker, and K8. the project used MQTT for device communication, Redis for state management, and Kafka to stream data into Cassandra for scalable storage.",
			],
			logo: ["../java.svg","../javascript.svg","../spring.svg", "../react.svg","../nodejs.svg","../mysql.svg","../cassandra.svg","../docker.svg"],
			linkText: "View Project",
			link: "",
		},
		{
			title: "Passerby Diary Project - Full Stack / Microservices ",
			descriptions:[
				"Created a scalable diary website that allows users to create and share their diaries using React, and Node.js",
				"Architected a microservices-architecture back-end system utilizing Java, Spring Boot, Spring Cloud, Netflix Eureka",
				"Integrated MySQL and MongoDB for efficient data storage and retrieval, and employed Kafka for real-time data streaming and processing",
				"Implemented Docker for containerization and deployment, and used Spring Security and JWT for secure user authentication and authorization",
			],
			logo: ["../java.svg","../javascript.svg","../spring.svg", "../react.svg","../nodejs.svg","../mysql.svg","../mongodb.svg","../docker.svg"],
			linkText: "View Project",
			link: "https://github.com/mengyunxie/passerby",
		},
		{
			title: "E-Commerce Database Management System",
			descriptions:[
				"Target 2.0 is a comprehensive e-commerce management system designed to streamline the end-to-end online shopping experience. It supports core retail operations including customer account management, product cataloging, shopping cart functionality, order processing, coupon promotions, and customer support. ",
				"Designed a fully normalized relational schema with 20+ interconnected entities to manage customers, products, orders, coupons, shipping, and support workflows.",
				"Implemented stored procedures, views, triggers, and computed columns for dynamic operations like order processing, stock updates, and real-time pricing calculations with coupon discounts.",
				"Applied data encryption and hashing (passwords, emails, phone numbers) using symmetric keys and certificates to ensure customer data privacy and secure transactions."
			],
			logo: ["../batabase.png","../sql_server.svg","../dbeaver.png"],
			linkText: "View Project",
			link: "https://github.com/mengyunxie/E-Commerce-Database-Management-System",
		},
		{
			title: "Twitter Sensitive Analysis Project - Machine Learning ",
			descriptions:[
				"Conducted a comprehensive analysis of Twitter data to help companies gain insights into public opinion about their brands, products, or services for business strategy, market analysis, and social research using Python, scikit-learn, seaborn, nltk.",
				"Developed and evaluated machine learning models with hyperparameter tuning, achieving an accuracy of 85% with Logistic Regression, demonstrating the model's efficiency and reliability.",
			],
			logo: ["../python.svg","../ai.png"],
			linkText: "View Project",
			link: "https://github.com/mengyunxie/twitter-sensitive-analysis",
		},
		{
			title: "JavaNet: TCP & UDP",
			descriptions:[
				"This project simulates real-world client-server communication using both TCP and UDP protocols to demonstrate the trade-offs between reliability and speed in networked systems. It provides a foundation for building scalable communication services, such as chat applications, IoT device messaging, or multiplayer gaming backends. With multithreaded TCP support and lightweight UDP messaging, it highlights key networking concepts in a clean, testable, and CI-integrated Java codebase.",
				"Implemented Dual Protocol Communication in Java: Built both TCP (connection-oriented) and UDP (stateless) client-server systems, showcasing core differences in real-time data transfer and reliability handling.",
				"Designed Multithreaded TCP Server Architecture: Developed a scalable TCP server using ClientHandler.java to handle multiple simultaneous client connections efficiently.",
				"CI/CD with GitHub Actions + Full JUnit Testing: Integrated GitHub Actions for automated builds and tests using Maven and JUnit 5, ensuring robust code quality through continuous integration."
			],
			logo: ["../java.svg","../spring.svg","../junit.png","../github_action.png"],
			linkText: "View Project",
			link: "https://github.com/mengyunxie/chat-room",
		}
		
	],
	works: [
		{
			company: "IpserLab LLC",
			link: "",
			logo:"../work.png",
			title: "Software Engineer Intern",
			descriptions: [
				"Developed LindoFlex e-commerce platform's customization features using React, Spring Boot, and PostgreSQL, enhancing platform flexibility, scalability, and user experience.",
				"Implemented comprehensive unit testing and GitHub Actions CI/CD pipelines, reducing deployment time by 30% and eliminating critical production bugs."
			],
			location: "Mountain View, CA",
			time: "Sep 2024 – Dec 2024"
		},
		{
			company: "Northeastern University",
			link: "https://www.northeastern.edu/",
			logo:"../work.png",
			title: "Graduate Teaching Assistant",
			descriptions: [
				"Support the professor in organizing and enforcing rules, assisting with individual student cases, and grading assignments and exams.",
				"Assist students in studying, completing classwork, and taking on additional responsibilities as requested."
			],
			location: "Seattle, WA",
			time: "Jan 2024 – May 2024"
		},
		{
			company: "Sunsea Internet of Things Technology Co., Ltd.",
			link: "",
			logo:"../work.png",
			title: "Software Engineer",
			descriptions: [
				"Led the front-end team, architecting the B2B IoT Device Management System with TypeScript, React, React Router, and Rematch for state management, and integrated multi-language support via React-Intl, delivering a scalable IoT platform, empower IoT management capabilities, resulting in a 19% increase in user engagement.",
				"Spearheaded front-end technology stack selection and cross-departmental collaboration while providing leadership to team members, resulting in the successful delivery of a feature-rich platform that aligned with critical business requirements.",
				"Implemented YApi for mock API testing, established Prettier for code formatting, and set up a CI/CD pipeline with Jenkins to automate testing and deployment, reducing bugs by 80% and deployment time by 35%, ensuring robust, maintainable, and scalable system."
			],
			location: "Shenzhen, China",
			time: "April 2018 – July 2019"
		},
		{
			company: "Shenzhen Andmobi Technology Co., Ltd.",
			link: "",
			logo:"../work.png",
			title: "Software Engineer",
			descriptions: [
				"Developed a modular Education Management System website using React, optimized the interaction logic, lazy loading, code restructuring,  achieving an 10% performance boost and significantly improving user experience.",
				"Implemented and designed a mobile course system app using React Native with over 100 features, including chat and video functionalities, resulting in a 20% increase in new user registrations and improved the overall learning experience.",
			],
			location: "Shenzhen, China",
			time: "Aug. 2016 – Mar 2018"
		},
		{
			company: "Shenzhen Ningyuan Technology Co., Ltd. ",
			link: "",
			logo:"../work.png",
			title: "Software Engineer",
			descriptions: [
				"Developed and designed the International Medical website, and expanded the company's international market.",
				"Developed and maintained the Special Interview websites to promote the company's business and medical knowledge, increasing the number of users by 12%.",
			],
			location: "Shenzhen, China",
			time: ""
		}
	]
};

export default INFO;
